export default __webpack_public_path__ + "static/media/90acf2ed32052560.8fa64ce6c49319ff6f872f1ec840e495.svg";